import MenuService from './MenuService';

export const menuService = new MenuService();
